import React from 'react';

const Invoices = () => {
  return null;
}

export { Invoices };
